import React from 'react';
import BrowserFrame from './BrowserFrame';

interface NodeProps {
  x: number;
  y: number;
  label: string;
  sub: string;
  color: string;
  icon: string;
}

const Node: React.FC<NodeProps> = ({ x, y, label, sub, color, icon }) => (
  <div
    style={{
      position: 'absolute',
      left: `${x}%`,
      top: `${y}%`,
      transform: 'translate(-50%, -50%)',
      width: '92px',
      background: 'var(--white)',
      border: `1.5px solid ${color}`,
      borderRadius: '6px',
      padding: '.4rem .5rem',
      boxShadow: '0 4px 12px rgba(0,0,0,.06)',
      fontFamily: "'Montserrat', sans-serif",
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '.3rem', marginBottom: '.2rem' }}>
      <div style={{ width: '14px', height: '14px', background: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '3px', fontSize: '.55rem', fontWeight: 700 }}>
        {icon}
      </div>
      <div style={{ fontSize: '.45rem', fontWeight: 700, letterSpacing: '.05em', textTransform: 'uppercase', color: color }}>{sub}</div>
    </div>
    <div style={{ fontSize: '.55rem', fontWeight: 600, color: 'var(--ink)' }}>{label}</div>
  </div>
);

const WorkflowCanvas: React.FC = () => {
  return (
    <BrowserFrame url="miid.app/workflow/builder">
      <div style={{ padding: '1rem', background: 'var(--cream)', minHeight: '260px', fontFamily: "'Montserrat', sans-serif" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.9rem' }}>
          <div style={{ fontSize: '.72rem', fontWeight: 600, color: 'var(--ink)' }}>Workflow: Nouveau Lead</div>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.3rem', padding: '.15rem .4rem', background: 'rgba(184,146,42,.14)', borderRadius: '3px' }}>
            <span style={{ fontSize: '.48rem', fontWeight: 700, color: 'var(--gold-dark)', letterSpacing: '.1em' }}>ACTIF</span>
          </div>
        </div>

        {/* Canvas with grid */}
        <div
          style={{
            position: 'relative',
            height: '210px',
            background: 'var(--white)',
            border: '1px solid var(--border)',
            borderRadius: '4px',
            backgroundImage:
              'radial-gradient(circle, rgba(26,111,168,.1) 1px, transparent 1px)',
            backgroundSize: '16px 16px',
            overflow: 'hidden',
          }}
        >
          {/* Connecting lines */}
          <svg viewBox="0 0 400 200" preserveAspectRatio="none" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
            <path d="M 70 45 L 140 45 L 170 100 L 240 100" stroke="var(--blue)" strokeWidth="1.5" fill="none" strokeDasharray="4 3" />
            <path d="M 170 100 L 240 155" stroke="var(--blue)" strokeWidth="1.5" fill="none" strokeDasharray="4 3" />
            <path d="M 260 100 L 330 100" stroke="var(--blue)" strokeWidth="1.5" fill="none" strokeDasharray="4 3" />

            {/* Flow particle */}
            <circle r="3" fill="var(--gold)">
              <animateMotion dur="3s" repeatCount="indefinite" path="M 70 45 L 140 45 L 170 100 L 240 100 L 330 100" />
            </circle>
          </svg>

          <Node x={17} y={22} label="Formulaire" sub="Trigger" color="#2E7D32" icon="▶" />
          <Node x={42} y={50} label="Si score > 80" sub="Condition" color="var(--gold-dark)" icon="◆" />
          <Node x={65} y={50} label="Salesforce" sub="Action" color="var(--blue)" icon="→" />
          <Node x={65} y={78} label="Email Slack" sub="Notifier" color="#5E35B1" icon="✉" />
          <Node x={88} y={50} label="Log DB" sub="Finish" color="#0F2744" icon="✓" />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.7rem', fontSize: '.52rem', color: 'var(--ink2)' }}>
          <span>5 étapes · 2.4s exécution moyenne</span>
          <span style={{ color: '#2E7D32', fontWeight: 600 }}>● 1 247 exécutions / jour</span>
        </div>
      </div>
    </BrowserFrame>
  );
};

export default WorkflowCanvas;
